import { settings } from "app";
import React, { useState } from "react";
import {
  Button,
  Datagrid,
  DateField,
  FunctionField,
  ListContextProvider,
  NumberField,
  ReferenceField,
} from "react-admin";
import { useNotifyError } from "utils/useNotifyError";
import HistoryIcon from "@mui/icons-material/History";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import UserField from "server/components/Fields/UserField";

const RequirementsHistoryDialog = ({ studentEducationId, requirementId, planId }) => {
  const notifyError = useNotifyError();
  const [requirementsHistory, setRequirementsHistory] = useState([]);

  const fetchRequirementsHistory = async () => {
    try {
      const { data } = await dataProvider.customRequest(
        graduationRequests.getStudentRequirementHistory(studentEducationId, requirementId),
      );
      setRequirementsHistory(data);
    } catch (err) {
      notifyError(err);
      return false;
    }
  };

  return (
    <ConfirmModal
      onOpen={fetchRequirementsHistory}
      titleContent={"История на промените"}
      isConfirmButton={false}
      dialogSize="xl"
      triggerButton={
        <Button
          label="История на промените"
          variant="contained"
          startIcon={<HistoryIcon />}
        />
      }
    >
      <ListContextProvider value={{ data: requirementsHistory }}>
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
        >
          <ReferenceField
            label="Норматив"
            source="requirementId"
            reference={graduationRequests.getPlanDisciplinesRequirements(planId)}
          >
            <FunctionField
              render={rec => (
                <div style={{ display: "flex", flexDirection: "column", padding: "4px 0" }}>
                  <span>
                    Име норматив: <strong>{rec.requirementNameBg}</strong>
                  </span>
                  <span>
                    Дисциплина: <strong>{rec.disciplineNameBg}</strong>
                  </span>
                  <span>
                    Норматив: <strong>{rec.requiredCount}</strong>
                  </span>
                </div>
              )}
            />
          </ReferenceField>
          <NumberField
            source="achievedCount"
            label="Изпълнено"
          />
          <UserField
            source="createdByUserId"
            label="Служител"
          />
          <DateField
            source="createdOn"
            label="Дата на създаване"
            locales="bg-BG"
            showTime
          />
        </Datagrid>
      </ListContextProvider>
    </ConfirmModal>
  );
};

export default RequirementsHistoryDialog;
